import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sdg-dashboard-by-sdg" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-list" }
const _hoisted_4 = { class: "stats" }
const _hoisted_5 = { class: "stat-card__title" }
const _hoisted_6 = { class: "stat-card__stat" }
const _hoisted_7 = { class: "stat-card__stat-value" }
const _hoisted_8 = { class: "chart" }

import { ref } from "vue";

import ViSelect from "@/components/elements/vi-select/vi-select.vue";
import ViBarChart from "@/components/elements/vi-charts/bar/vi-bar-chart.vue";
import ViRatingBar from "@/components/elements/vi-rating-bar/vi-rating-bar.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'sdg-impact-by-company',
  setup(__props) {

const selectedCompany = ref("a87dfga");
const companiesList = ref([
  {
    uid: "a87dfga",
    value: "a87dfga",
    label: "Pixelmatters",
  },
]);
const stats = ref([
  {
    title: "Impact Rating",
    valueLabel: "AAA",
    value: undefined,
  },
  {
    title: "Impact Score",
    valueLabel: "35",
    value: 35,
  },
  {
    title: "Positive Impact",
    valueLabel: "+40",
    value: 40,
  },
  {
    title: "Negative Impact",
    valueLabel: "-5",
    value: -5,
  },
]);

const data = ref({
  labels: ["SDG 3: Health", "SDG 8: Economey & Jobs", "SDG 9: Infrastructure"],
  datasets: [
    {
      data: [50, 35, 20],
      backgroundColor: ["#4C9F38", "#A21942", "#FD6925"],
    },
  ],
});
const options = ref({
  scales: {
    y: {
      min: 0,
      max: 100,
    },
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-title" }, "Pixelmatters", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", null, "SELECT COMPANY", -1)),
        _createVNode(ViSelect, {
          options: companiesList.value,
          "selected-option": selectedCompany.value
        }, null, 8, ["options", "selected-option"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stats.value, (stat) => {
        return (_openBlock(), _createElementBlock("div", {
          key: stat.value,
          class: "stat-card"
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(stat.title), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(stat.valueLabel), 1),
            (typeof stat.value === 'number')
              ? (_openBlock(), _createBlock(ViRatingBar, {
                  key: 0,
                  value: stat.value
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "chart__header" }, [
        _createElementVNode("span", { class: "chart__title" }, "Top positively impacted SDGs"),
        _createElementVNode("span", { class: "chart__link" }, "How impact is measured")
      ], -1)),
      _createVNode(ViBarChart, {
        data: data.value,
        scales: options.value.scales
      }, null, 8, ["data", "scales"])
    ])
  ]))
}
}

})